export default "__VITE_ASSET__B5FXCeH8__"